var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 33,
    viewBox: "0 0 54 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.118 20.5014V27.3834L0.154317 13.3106L16.118 0.211414V6.11444V6.21444H16.218H33.1895V9.61117H31.9669V7.9128V7.8128H31.8669H14.8954V3.23706V3.02522L14.7318 3.15985L2.49718 13.2307L2.40695 13.305L2.49428 13.3826L14.7289 24.2627L14.8954 24.4108V24.188V18.803H18.9632V20.4014H16.218H16.118V20.5014Z",
    fill: "#454545",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6574 11.5096V5.60656L53.6211 18.7058L37.6574 32.7786V25.8965V25.7965H37.5574H20.5858V11.6096H37.5574H37.6574V11.5096ZM21.8085 24.0981V24.1981H21.9085H38.88V29.5831V29.8047L39.0462 29.6581L51.2808 18.868L51.3684 18.7907L51.2785 18.716L39.0439 8.55527L38.88 8.41916V8.6322V13.2079H21.9085H21.8085V13.3079V24.0981Z",
    fill: "#454545",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionIcon);
export default __webpack_public_path__ + "static/media/direction-icon.990b46abb4cf01882097fa8c81e82fef.svg";
export { ForwardRef as ReactComponent };